import { CLIENT_CONTROLLER } from '@/constants';
import { error } from '@/utils/error';
import { getHttpService } from './HttpService';

export const SESSION_KEY_CONTACT_INFORMATION = 'contactInformation';

interface RenderInfoResponse {
    data: RenderInfo;
}

interface RenderInfo {
    aantalDagenTotStartPremiejaar: number;
    genderQuestionEnabled: boolean;
    isCampagneperiode: boolean;
    premiejaar: number;
    showProvisionInfo: boolean;
    taal: 'nl' | 'en';
}

interface ContactInformationResponse {
    data: ContactInformation;
}

export interface ContactInformation {
    channel?: ContactChannelInfo;
}

export interface ContactChannelInfo {
    channelName?: string;
    isAvailable?: boolean;
    nextAvailable?: ContactAvailability;
    message?: string;
}

export interface ContactAvailability {
    date?: string;
    fromTime?: string;
    toTime?: string;
}

const getContent = async (brand: string): Promise<RenderInfo> => {
    const HttpService = getHttpService();
    const path = `/clientcontroller/salesfunnelclient/ophalenrenderinfo?propositie=${brand}`;
    const { data } = (await HttpService.get(path)) as RenderInfoResponse;

    if (data.taal === undefined) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, {
            path,
            brand
        });
    }

    return data;
};

const getContactInformation = async (): Promise<ContactInformation> => {
    const HttpService = getHttpService();
    const path = `/clientcontroller/salesfunnelclient/GetContactInformation`;
    const { data } = (await HttpService.get(path)) as ContactInformationResponse;

    if (!data) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, { path });
    }

    return data;
};

export default {
    getContent,
    getContactInformation
};
